import { selectEditorPreviewWidgetComponentName, selectEditorPreviewWidgetComponentProps } from "../draft-selectors";
import { DatapointKind } from "../types";
import { getDatapointRequestElementFromColumnOptionState, getIdDimensionDatapointName } from "../utils";
import { DatapointIdStandardEnum } from "api/ux/src";
export const isDimensionName = (dimension) => {
    switch (dimension) {
        case DatapointIdStandardEnum.AssetAssetName:
        case DatapointIdStandardEnum.FundFundName:
        case DatapointIdStandardEnum.ManagerManagerName: {
            return true;
        }
        default: {
            return false;
        }
    }
};
export const isDimensionId = (dimension) => {
    switch (dimension) {
        case DatapointIdStandardEnum.AssetAssetId:
        case DatapointIdStandardEnum.FundFundId:
        case DatapointIdStandardEnum.ManagerManagerId: {
            return true;
        }
        default: {
            return false;
        }
    }
};
export const convertDimensionFromNameToId = (dimension) => {
    switch (dimension) {
        case DatapointIdStandardEnum.AssetAssetName: {
            return DatapointIdStandardEnum.AssetAssetId;
        }
        case DatapointIdStandardEnum.FundFundName: {
            return DatapointIdStandardEnum.FundFundId;
        }
        case DatapointIdStandardEnum.ManagerManagerName: {
            return DatapointIdStandardEnum.ManagerManagerId;
        }
        default: {
            return dimension;
        }
    }
};
export const convertDimensionFromIdToName = (dimension) => {
    switch (dimension) {
        case DatapointIdStandardEnum.AssetAssetId: {
            return DatapointIdStandardEnum.AssetAssetName;
        }
        case DatapointIdStandardEnum.FundFundId: {
            return DatapointIdStandardEnum.FundFundName;
        }
        case DatapointIdStandardEnum.ManagerManagerId: {
            return DatapointIdStandardEnum.ManagerManagerName;
        }
        default: {
            return dimension;
        }
    }
};
export const updateOrAddDatapointRequestToPreviewComponentProps = (componentProps, datapointRequestElement, datapointKind) => {
    if (!datapointRequestElement) {
        return;
    }
    if (!componentProps.datapointParams || componentProps.datapointParams.length < 1 ||
        (!componentProps.datapointParams[0].measures && !componentProps.datapointParams[0].dimensions)) {
        componentProps.datapointParams = [{ dimensions: [], measures: [] }];
    }
    const datapoints = datapointKind === DatapointKind.Dimension ? componentProps.datapointParams[0].dimensions : componentProps.datapointParams[0].measures;
    const existingDatapointIndex = datapoints
        .findIndex((c) => c.name === datapointRequestElement.name);
    if (existingDatapointIndex === -1) {
        datapoints.push(datapointRequestElement);
    }
    else {
        datapoints[existingDatapointIndex] = { ...datapoints[existingDatapointIndex], ...datapointRequestElement };
    }
};
export const updateOrAddDatapointRequest = (state, columnOptionState) => {
    const componentProps = selectEditorPreviewWidgetComponentProps(state);
    if (componentProps) {
        updateOrAddDatapointRequestToPreviewComponentProps(componentProps, getDatapointRequestElementFromColumnOptionState(columnOptionState), columnOptionState.datapointKind);
    }
};
export const updateOrAddDatapointRequests = (state, columnOptionStates) => {
    columnOptionStates.forEach((c) => updateOrAddDatapointRequest(state, c));
};
export const removeManyDatapointRequests = (state, names) => {
    const componentProps = selectEditorPreviewWidgetComponentProps(state);
    if (!componentProps || componentProps?.datapointParams?.length < 1) {
        return;
    }
    if (componentProps?.datapointParams[0].measures) {
        const measures = componentProps.datapointParams[0].measures;
        const componentName = selectEditorPreviewWidgetComponentName(state);
        if (measures.length > 0 && componentName !== "InsDatapointGridWidget") {
            measures.forEach((element) => {
                if (isDimensionName(element.standardDatapoint)) {
                    const dimension = componentProps.datapointParams[0].dimensions
                        .filter((c) => c.standardDatapoint === convertDimensionFromNameToId(element.standardDatapoint));
                    if (dimension.length > 0) {
                        names.push(convertDimensionFromNameToId(dimension[0].name));
                    }
                }
            });
        }
        componentProps.datapointParams[0].measures = componentProps.datapointParams[0].measures.filter((c) => names.findIndex((name) => c.name === name) === -1);
    }
    if (componentProps.datapointParams[0].dimensions) {
        componentProps.datapointParams[0].dimensions = componentProps.datapointParams[0].dimensions.filter((c) => names.findIndex((name) => c.name === name) === -1);
    }
};
export const removeDatapointRequest = (state, name) => {
    const componentProps = selectEditorPreviewWidgetComponentProps(state);
    if (!componentProps || componentProps?.datapointParams?.length < 1) {
        return;
    }
    const measure = componentProps.datapointParams[0].measures?.find((c) => c.name === name);
    if (measure) {
        componentProps.datapointParams[0].measures = componentProps.datapointParams[0].measures.filter((c) => c.name !== name);
    }
};
export const removeManyDataSelectProps = (state, names) => {
    const componentProps = selectEditorPreviewWidgetComponentProps(state);
    if (componentProps.dataSelectProps?.length) {
        for (const select of componentProps.dataSelectProps) {
            for (const name of names) {
                if (name in select.selectValues) {
                    delete select.selectValues[name];
                }
                else if (getIdDimensionDatapointName(name) in select.selectValues) {
                    delete select.selectValues[getIdDimensionDatapointName(name)];
                }
            }
        }
    }
};
